window.checkKeyboard = (element) => {
    if (window.innerWidth <= 830) {
        window.visualViewport.onresize = () => {
            const viewportHeight = window.visualViewport.height;

            if (document.activeElement.value !== undefined) {
                element.classList.add('relative');
                element.style.height  = viewportHeight+'px';
            } else {
                element.classList.remove('relative');
                element.style.height  = null;
            }
        }
    }
}
